import type { TypeTaskMap } from '@/types/work/types.work.map';

export const EMPTY_MAP: TypeTaskMap = { type: 'data', edgeStyle: 'curve', groups: [], nodes: [], edges: [], views: [] };
